import React from 'react';
import './NotFound.css';
const NotFound = () => {
    return (
        <div className="not-found">
            <h1>404</h1>
            <div class="cloak__wrapper">
            <div class="cloak__container">
                <div class="cloak"></div>
            </div>
            </div>
        </div>
    );
};

export default NotFound;